export const API_CHANGE_PASSWORD = '/user/change-password/';
export const API_RESET_PASSWORD = '/user/reset-password/';
export const API_SUBMIT_OTP = '/user/submit-otp/';
export const API_INTEREST_LIST = '/user/interest-list';
export const API_GET_TASK_BY_DATE = '/task/tasksByDate';
